import React from 'react'
import classNames from 'classnames'

export function MainWrapper({ children }) {
  return (
    <div className="radius-normal" style={{ maxWidth: 1200, width: '100%' }}>
      {children}
    </div>
  )
}

export function HeaderWrapper({ children }) {
  return (
    <div
      className={classNames([
        'flexbox flexbox-align-center',
        'border-bottom-small border-shade-50',
      ])}
    >
      {children}
    </div>
  )
}

export function HeaderSideWrapper({ children }) {
  return (
    <div
      className="border-right-small border-shade-50"
      style={{ flex: '0 0 300px' }}
    >
      {children}
    </div>
  )
}

export function BodyWrapper({ children }) {
  return (
    <div className="flexbox" style={{ height: '80vh' }}>
      {children}
    </div>
  )
}

export function BodySidePanel({ children }) {
  return (
    <div
      className="border-right-small border-shade-50 scroll-y"
      style={{ flex: '0 0 300px' }}
    >
      {children}
    </div>
  )
}

export function Body({ children }) {
  return (
    <div className="flexbox-grow padding-top-largest history-panel scroll-y">
      {children}
    </div>
  )
}
